(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sp-pdp[data-section-id]').forEach(function (root) {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      var productEl = root.querySelector('[data-product-json]');
      if (!productEl) return;
      var product = null;
      try { product = JSON.parse(productEl.textContent || '{}'); } catch (e) { return; }
      if (!product || !product.variants) return;

      var currency = root.getAttribute('data-currency') || 'USD';
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var saveEl = root.querySelector('[data-save]');
      var saveAmountEl = root.querySelector('[data-save-amount]');
      var savePctEl = root.querySelector('[data-save-pct]');
      var deskPrice = root.querySelector('[data-desk-price]');
      var deskThumb = root.querySelector('[data-desk-thumb]');
      var deskBar = root.querySelector('[data-desk-bar]');
      var buyBox = root.querySelector('[data-pdp-buy]');
      var variantInput = root.querySelector('[data-variant-id]');
      var submit = root.querySelector('[data-submit]');
      var mobileSubmit = root.querySelector('[data-mobile-submit]');
      var deskSubmit = root.querySelector('[data-desk-submit]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
      var deskSelects = Array.prototype.slice.call(root.querySelectorAll('[data-desk-option]'));
      var rewardsPoints = root.querySelector('[data-rewards-points]');
      var payMonthly = root.querySelector('[data-pay-monthly]');
      var payQuad = root.querySelector('[data-pay-quad]');
      var currentSlide = 0;
      var syncingFromDesk = false;

      function money(cents) {
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format((cents || 0) / 100); }
        catch (e) { return ((cents || 0) / 100).toFixed(2); }
      }

      function showSlide(i) {
        if (!slides.length) return;
        currentSlide = Math.max(0, Math.min(i, slides.length - 1));
        slides.forEach(function (slide, index) {
          var on = index === currentSlide;
          slide.hidden = !on;
          slide.classList.toggle('is-active', on);
        });
        thumbs.forEach(function (thumb, index) { thumb.classList.toggle('is-active', index === currentSlide); });
      }

      function selectedOptions() {
        var picked = [];
        for (var i = 0; i < product.options.length; i += 1) {
          var active = root.querySelector('[data-option-index="' + i + '"].is-active');
          picked.push(active ? active.getAttribute('data-option-value') : null);
        }
        return picked;
      }

      function findVariant() {
        var picked = selectedOptions();
        return product.variants.find(function (variant) {
          for (var i = 0; i < picked.length; i += 1) {
            if (picked[i] && variant.options[i] !== picked[i]) return false;
          }
          return true;
        }) || product.variants[0];
      }

      function syncVariant() {
        var variant = findVariant();
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (deskPrice) deskPrice.textContent = money(variant.price);
        if (compareEl) {
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.hidden = !onSale;
          compareEl.textContent = onSale ? money(variant.compare_at_price) : '';
          if (saveEl) {
            saveEl.hidden = !onSale;
            if (onSale) {
              var saved = variant.compare_at_price - variant.price;
              if (saveAmountEl) saveAmountEl.textContent = '\u2212' + money(saved);
              if (savePctEl) savePctEl.textContent = '';
            }
          }
        }
        if (rewardsPoints) rewardsPoints.textContent = String(Math.max(1, Math.round((variant.price || 0) / 100)));
        if (payMonthly) {
          payMonthly.textContent = money(Math.round((variant.price || 0) / 3)) + '/month';
        }
        if (payQuad) {
          payQuad.textContent = money(Math.round((variant.price || 0) / 4));
        }
        [submit, mobileSubmit, deskSubmit].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? (btn.dataset.addLabel || 'ADD TO CART') : (btn.dataset.soldLabel || 'Sold out');
        });
        var picked = selectedOptions();
        picked.forEach(function (val, idx) {
          var el = root.querySelector('[data-option-label="' + idx + '"]');
          if (el && val) el.textContent = val;
          if (!syncingFromDesk) {
            var deskSel = root.querySelector('[data-desk-option="' + idx + '"]');
            if (deskSel && val && deskSel.value !== val) deskSel.value = val;
          }
        });
        if (variant.featured_media && variant.featured_media.id) {
          var id = String(variant.featured_media.id);
          slides.forEach(function (slide, index) {
            if (slide.getAttribute('data-media-id') === id) showSlide(index);
          });
          if (deskThumb) {
            var mosaic = root.querySelector('[data-mosaic-tile][data-media-id="' + id + '"] img');
            if (mosaic) {
              deskThumb.src = mosaic.currentSrc || mosaic.src;
            }
          }
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { showSlide(parseInt(thumb.dataset.index || '0', 10)); });
      });

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optionIndex = btn.dataset.optionIndex;
          root.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(function (peer) {
            peer.classList.remove('is-active');
            peer.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          syncVariant();
        });
      });

      deskSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var optionIndex = sel.getAttribute('data-desk-option');
          var value = sel.value;
          syncingFromDesk = true;
          var match = null;
          root.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(function (peer) {
            if (peer.getAttribute('data-option-value') === value) match = peer;
          });
          if (match) match.click();
          else syncVariant();
          syncingFromDesk = false;
        });
      });

      if (deskBar && buyBox && 'IntersectionObserver' in window) {
        deskBar.hidden = false;
        var headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bh-header-offset'), 10) || 72;
        var deskObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting && entry.boundingClientRect.top < headerOffset;
            deskBar.classList.toggle('is-visible', show);
          });
        }, {
          root: null,
          threshold: 0,
          rootMargin: '-' + headerOffset + 'px 0px 0px 0px'
        });
        deskObserver.observe(buyBox);
      }

      var gallery = root.querySelector('[data-gallery]');
      if (gallery) {
        var startX = 0;
        var startY = 0;
        gallery.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches.length) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });
        gallery.addEventListener('touchend', function (e) {
          if (!e.changedTouches || !e.changedTouches.length) return;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) showSlide(currentSlide + 1);
          else showSlide(currentSlide - 1);
        }, { passive: true });
      }

      var sizeGuide = document.querySelector('[data-size-guide]');
      root.querySelectorAll('[data-size-guide-open]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          if (!sizeGuide) return;
          sizeGuide.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });
      if (sizeGuide) {
        sizeGuide.querySelectorAll('[data-size-guide-close]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            sizeGuide.hidden = true;
            document.documentElement.style.overflow = '';
          });
        });
      }

      var lightbox = document.querySelector('[data-lightbox]');
      var lightboxImg = lightbox && lightbox.querySelector('[data-lightbox-img]');
      root.querySelectorAll('[data-zoom-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!lightbox || !lightboxImg || !slides[currentSlide]) return;
          var img = slides[currentSlide].querySelector('img');
          if (!img) return;
          lightboxImg.src = img.currentSrc || img.src;
          lightboxImg.alt = img.alt || '';
          lightbox.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });
      if (lightbox) {
        lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            lightbox.hidden = true;
            document.documentElement.style.overflow = '';
          });
        });
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) {
            lightbox.hidden = true;
            document.documentElement.style.overflow = '';
          }
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (sizeGuide && !sizeGuide.hidden) {
          sizeGuide.hidden = true;
          document.documentElement.style.overflow = '';
        }
        if (lightbox && !lightbox.hidden) {
          lightbox.hidden = true;
          document.documentElement.style.overflow = '';
        }
      });

      showSlide(0);
      syncVariant();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
